import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './SkillsLevel.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import RowLevel from './RowLevel/RowLevel'
import AddSkillsLevelModal from './AddSkillsLevelModal/AddSkillsLevelModal'
import Loader from 'components/UI/Loader/Loader'
import useLocalization from 'hooks/useLocalization'

const initPagination = {
  page: 1,
  limit: 10,
}

const SkillsLevel = () => {
  const [skillLevel, setSkillLevel] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'group_setting',
    dict: {
      skill_levels: 'Skill levels',
      entries: 'Entries ',
      add_skill_level: 'Add skill level',
      edit: 'Edit',
      name: 'Name',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
    },
  })

  const fetchSkills = () => {
    superAxiosRequest({
      method: 'get',
      link: 'groups/skilllevels',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setSkillLevel(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchSkills()
  }, [pagination])

  const onBeforeSubmitClient = (data) => {
    const { name, company, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
      ...(company && { company: data.company }),
    }
  }

  const addSkillLevel = () => {
    const ms = {
      modalBodyComponent: () => <AddSkillsLevelModal translate={translate} />,
      button: translate.save,
      link: 'groups/skilllevels',
      title: translate.add_skill_level,
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchSkills()
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, {})
  }

  const editSkilLevel = (data) => {
    const ms = {
      modalBodyComponent: () => <AddSkillsLevelModal translate={translate} />,
      button: translate.save,
      link: `groups/skilllevels/${data?.id}`,
      title: 'Edit skills level',
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setSkillLevel((prev) => {
          return {
            ...prev,
            result: prev.result.map((program) =>
              program.id === data.id ? { ...program, ...data } : program,
            ),
          }
        })
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteSkillLevel = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the skills level?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `groups/skilllevels/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setSkillLevel((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editSkilLevel(items)],
      ['delete', () => deleteSkillLevel(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={translate.skill_levels}>
          <HeaderAddButton
            title={translate.add_skill_level}
            onClick={addSkillLevel}
          />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            {translate.entries}: {skillLevel?._meta?.count_items}
          </div>
          <div>
            {skillLevel?.result?.map((level, index) => (
              <RowLevel
                key={level.id}
                level={level}
                index={index}
                action={action}
                translate={translate}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {skillLevel?._meta.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={skillLevel._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default SkillsLevel
